import React, { useState, useEffect } from 'react';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import { Button, Modal, Form, Table, Alert, Card } from 'react-bootstrap';
import axios from 'axios';
import BaseUrl from '../../ApiServices/BaseUrl';
import ReactPaginate from 'react-paginate';
import './ManageJobpositions.css'; // Optional if you want custom pagination styles

function ManageJobpositions() {
    const [showModal, setShowModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [jobPositions, setJobPositions] = useState([]);
    const [viewData, setViewData] = useState(null);
    const [formData, setFormData] = useState({
        position: '',
        category: 'Domestic helper', // ✅ Default category
        description: ''
    });
    const [alert, setAlert] = useState({
        show: false,
        message: '',
        variant: 'success'
    });

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    // Fetch job positions on component mount
    useEffect(() => {
        fetchJobPositions();
    }, []);

    const fetchJobPositions = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/jobposition`);
            // Sort by ID in descending order to show newest first
            const sortedData = response.data.sort((a, b) => b.id - a.id);
            setJobPositions(sortedData);
        } catch (error) {
            showAlert('Error fetching job positions', 'danger');
            console.error('Error fetching job positions:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditMode) {
                await axios.put(`${BaseUrl}/api/jobposition/${currentId}`, formData);
                showAlert('Job position updated successfully', 'success');
            } else {
                await axios.post(`${BaseUrl}/api/jobposition`, formData);
                showAlert('Job position added successfully', 'success');
            }
            resetForm();
            fetchJobPositions();
        } catch (error) {
            showAlert('Error saving job position', 'danger');
            console.error('Error saving job position:', error);
        }
    };

    const handleEdit = async (id) => {
        try {
            const response = await axios.get(`${BaseUrl}/api/jobposition/${id}`);
            setFormData({
                position: response.data.position,
                category: response.data.category,
                description: response.data.description || ''
            });
            setCurrentId(id);
            setIsEditMode(true);
            setShowModal(true);
        } catch (error) {
            showAlert('Error loading job position', 'danger');
            console.error('Error loading job position:', error);
        }
    };

    const handleView = async (id) => {
        try {
            const response = await axios.get(`${BaseUrl}/api/jobposition/${id}`);
            setViewData(response.data);
            setShowViewModal(true);
        } catch (error) {
            showAlert('Error loading job position details', 'danger');
            console.error('Error loading job position details:', error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this job position?')) {
            try {
                await axios.delete(`${BaseUrl}/api/jobposition/${id}`);
                showAlert('Job position deleted successfully', 'success');
                fetchJobPositions();
            } catch (error) {
                showAlert('Error deleting job position', 'danger');
                console.error('Error deleting job position:', error);
            }
        }
    };

    const resetForm = () => {
        setFormData({
            position: '',
            category: 'Domestic helper', // ✅ Reset to default category
            description: ''
        });
        setCurrentId(null);
        setIsEditMode(false);
        setShowModal(false);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setViewData(null);
    };

    const showAlert = (message, variant) => {
        setAlert({ show: true, message, variant });
        setTimeout(() => setAlert({ ...alert, show: false }), 5000);
    };

    // Pagination calculations
    const offset = currentPage * itemsPerPage;
    const currentItems = jobPositions.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(jobPositions.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <>
            <AdminNavbar />
            <div className="container" style={{ marginTop: '80px' }}>
                {alert.show && (
                    <Alert variant={alert.variant} onClose={() => setAlert({ ...alert, show: false })} dismissible>
                        {alert.message}
                    </Alert>
                )}

<div className="d-flex flex-row justify-content-between align-items-center mb-2">
  <h2 className="mb-2 mb-md-0">Manage Job Positions</h2>
  <Button className="managejobpositions-add-button" variant="primary" onClick={() => setShowModal(true)}>
    Add Job Position
  </Button>
</div>



<div className="table-wrapper">
    <div className="table-scroll">
        <Table striped bordered hover className="job-positions-table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Position</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {currentItems.length > 0 ? (
                    currentItems.map((position, index) => (
                        <tr key={position.id}>
                            <td>{offset + index + 1}</td>
                            <td>{position.position}</td>
                            <td>{position.category}</td>
                            <td>
                                {position.description ? (
                                    position.description.length > 30
                                        ? `${position.description.substring(0, 30)}...`
                                        : position.description
                                ) : (
                                    <span className="text-muted">No description</span>
                                )}
                            </td>
                            <td>
                                <div className="managejobposition-buttons">
  <Button
    variant="primary"
    size="sm"
    className="me-2"
    onClick={() => handleView(position.id)}
  >
    View
  </Button>
  <Button
    variant="primary"
    size="sm"
    className="me-2"
    onClick={() => handleEdit(position.id)}
  >
    Edit
  </Button>
  <Button  
    variant="danger"
    size="sm"
    onClick={() => handleDelete(position.id)}
  >
    Delete
  </Button>
</div>

                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" className="text-center">
                            No job positions found.
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>
</div>

{/* ✅ Pagination OUTSIDE scrollable area */}
{pageCount > 1 && (
    <ReactPaginate
        previousLabel={'Previous'}
        nextLabel={'Next'}
        breakLabel={'...'}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={handlePageClick}
        containerClassName={'pagination justify-content-center'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        activeClassName={'active'}
        forcePage={currentPage}
    />
)}

                {/* Add/Edit Job Position Modal */}
                <Modal show={showModal} onHide={resetForm} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{isEditMode ? 'Edit' : 'Add New'} Job Position</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="position" className="mb-3">
                                <Form.Control
                                    type="text"
                                    name="position"
                                    value={formData.position}
                                    onChange={handleInputChange}
                                    required
                                    placeholder="Enter job position title"
                                />
                            </Form.Group>

                            <Form.Group controlId="category" className="mb-3">
                                <Form.Control
                                    as="select"
                                    name="category"
                                    value={formData.category}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select category</option>
                                    <option value="Domestic Helper">Domestic Helper</option>
                                    <option value="Company">Company</option>
                                    <option value="Any">Any</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group controlId="description" className="mb-3">
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    placeholder="Enter job position description (optional)"
                                />
                            </Form.Group>

                            <div className="d-flex justify-content-end">
                                <Button variant="secondary" onClick={resetForm} className="me-2">
                                    Cancel
                                </Button>
                                <Button variant=""  className="managejobpositionsave" type="submit">
                                    {isEditMode ? 'Update' : 'Save'}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* View Job Position Details Modal */}
                <Modal show={showViewModal} onHide={closeViewModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Job Position Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {viewData && (
                            <Card>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <strong>ID:</strong>
                                                <p className="text-muted">{viewData.id}</p>
                                            </div>
                                            <div className="mb-3">
                                                <strong>Position:</strong>
                                                <p className="text-muted">{viewData.position}</p>
                                            </div>
                                            <div className="mb-3">
                                                <strong>Category:</strong>
                                                <p className="text-muted">{viewData.category}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <strong>Description:</strong>
                                                {viewData.description ? (
                                                    <div
                                                        style={{
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '10px',
                                                            borderRadius: '0px',
                                                            border: '1px solid #dee2e6'
                                                        }}
                                                    >
                                                        <p className="text-muted mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                                                            {viewData.description}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <p className="text-muted">No description provided</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeViewModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    );
}

export default ManageJobpositions;

